import { render, staticRenderFns } from "./FocusIndustry.vue?vue&type=template&id=b256922a&scoped=true"
import script from "./FocusIndustry.vue?vue&type=script&lang=js"
export * from "./FocusIndustry.vue?vue&type=script&lang=js"
import style0 from "./FocusIndustry.vue?vue&type=style&index=0&id=b256922a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b256922a",
  null
  
)

export default component.exports